import { SaveAlt, ArrowDropDown } from '@mui/icons-material';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import stateList from '../../../../utils/stateList.json';
import { usePermission } from '../../../../hooks/usePermission';

const ExportAll = (props) => {
  const { taxData,searchType,bookingNumber,startDate,endDate,year } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);


  const taxReportExportPermission = usePermission('tax-report-export');


  const exportMapping = [
    {
      header: 'Booking Number',
      value: (row) => `${row.bookingNumber}`
    },
    {
      header: 'Customer Name',
      value: (row) => `${row.customerName}`
    },
    {
      header: 'Customer Address',
      value: (row) => `${row.customerAddress}`
    },
    {
      header: 'State',
      value: (row) => `${row.state}`
    },
    {
      header: 'State Code',
      value: (row) => `${row.stateCode || ''}`
    },
    {
      header: 'serviceDate',
      value: (row) => row.serviceDate ? `="${row.serviceDate}"` : ''
    },
    {
      header: 'Charge Type',
      value: (row) => `${row.chargeType}`
    },
    {
      header: 'Service Name',
      value: (row) => `${row.serviceName ||''}`
    },
    {
      header: 'Sac Code',
      value: (row) => `${row.sacCode || ''}`
    },
    {
      header: 'RCM',
      value: (row) => `${row.rcm || ''}`
    },
    {
      header: 'Quantity',
      value: (row) => `${row.quantity}`
    },
    {
      header: 'Unit Price',
      value: (row) => `${row.unitPrice}`
    },
    {
      header: 'Base Amount',
      value: (row) => `${row.baseAmount}`
    },
    {
      header: 'Coin Disc.',
      value: (row) => `${row.coinDiscount}`
    },
    {
      header: 'Coupon Disc.',
      value: (row) => `${row.couponDiscount}`
    },
    {
      header: 'Taxable Amt.',
      value: (row) => `${row.taxableAmount}`
    },
    {
      header: 'IGST',
      value: (row) => `${row.igst}`
    },
    {
      header: 'CGST',
      value: (row) => `${row.cgst}`
    },
    {
      header: 'SGST',
      value: (row) => `${row.sgst}`
    },
    {
      header: 'IGST_NON',
      value: (row) => `${row.igstNon}`
    },
    {
      header: 'CGST_NON',
      value: (row) => `${row.cgstNon}`
    },
    {
      header: 'SGST_NON',
      value: (row) => `${row.sgstNon}`
    },
    {
      header: 'TCS',
      value: (row) => `${row.tcs}`
    },
    {
      header: 'Total GST',
      value: (row) => `${row.totalGst}`
    },
    {
      header: 'Final Amount',
      value: (row) => `${row.totalAmount}`
    },
    {
      header: 'GST Rate',
      value: (row) => `${row.taxRate || 0}%`
    },
  ];

  const getFileName = () => {
    return searchType === 'year'
      ? `booking-tax-summary-${year}`
      : searchType === 'booking'
        ? `booking-tax-summary-${bookingNumber}`
        : `booking-tax-summary-${dayjs(startDate).format('DD-MM-YYYY')}_to_${dayjs(endDate).format('DD-MM-YYYY')}`;
  };

  const downloadCsv = (mapping, fileName, isOfficial = false) => {
    const exportData = taxData.map((row, index) =>
      mapping.reduce((acc, field) => {
        acc[field.header] = field.value(row, index);
        return acc;
      }, {})
    );
    const headers = mapping.map(field => `"${field.header}"`).join(',');
    const rows = exportData.map(row =>
      mapping.map(field => {
        const val = String(row[field.header] ?? '').replace(/"/g, '""');
        return `"${isOfficial && val.trim() === '' ? '-' : val}"`;
      }).join(',')
    );
    rows.unshift(headers);
    const csvString = rows.join('\n');
    const blob = new Blob(['\uFEFF', csvString], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return url;
  };

  const handleExportAllRows = async () => {
    try {
      const fileName = getFileName();
      const url = downloadCsv(exportMapping, fileName);
      Swal.fire({
        title: 'Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="${fileName}.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  const officialExportMapping = [
    { header: 'SL. NO.',           value: (row, i) => `${i + 1}` },
    { header: 'Branch',            value: () => 'NOIDA' },
    { header: 'Invoice Type',      value: () => 'Tax Invoice' },
    { header: 'Invoice No',        value: (row) => `${row.bookingNumber}` },
    { header: 'Date',              value: (row) => row.serviceDate ? `="${dayjs(row.serviceDate).format('YYYY-MM-DD')}"` : '' },
    { header: 'State Code',        value: (row) => `${row.stateCode || ''}` },
    { header: 'Client Name',       value: (row) => `${row.customerName}` },
    { header: 'Client GST Number', value: () => '' },
    { header: 'Client PAN NUMBER', value: () => '' },
    { header: 'Client Adress',     value: (row) => `${row.customerAddress}` },
    { header: 'Narration',         value: (row) => `${row.serviceName || ''}` },
    { header: 'TAXABLE',           value: (row) => `${row.taxableAmount}` },
    { header: 'IGST',              value: (row) => `${row.igst}` },
    { header: 'CGST',              value: (row) => `${row.cgst}` },
    { header: 'SGST',              value: (row) => `${row.sgst}` },
    { header: 'Total GST',         value: (row) => `${row.totalGst}` },
    { header: 'Total Amount',      value: (row) => `${row.totalAmount}` },
    { header: 'Rate',              value: (row) => `${row.taxRate || 0}%` },
    { header: 'ACK',               value: () => '' },
    { header: 'IRN',               value: () => '' },
    { header: 'SAC Code',          value: (row) => `${row.sacCode || ''}` },
    { header: 'Our Entity Name',   value: () => 'CuDel Delight Solutions Pvt. Ltd' },
    { header: 'Entity GST number', value: () => '09AAHCC6070E1ZP' },
    { header: 'REMARKS',           value: () => 'Customer Tax Invoice' },
  ];

  const handleOfficialExport = async () => {
    try {
      const fileName = `GST-Output-Report-${getFileName()}`;
      const url = downloadCsv(officialExportMapping, fileName, true);
      Swal.fire({
        title: 'Official Export Successful',
        html: `<p>If download doesn't start automatically, click: <a href="${url}" download="${fileName}.csv" style="color:blue;text-decoration:underline;">Download CSV</a></p>`,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonText: 'Close'
      });
    } catch (error) {
      console.error('Official export failed', error);
      Swal.fire({ title: 'Export Failed', text: 'There was an issue exporting the data. Please try again.', icon: 'error' });
    }
  };

  return (
    <>
    {taxReportExportPermission.canView && (
    <Box>
      <Button
        onClick={handleMenuOpen}
        startIcon={<SaveAlt />}
        endIcon={<ArrowDropDown />}
        sx={{ textTransform: 'none' }}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem
          onClick={() => { handleExportAllRows(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Internal Export
        </MenuItem>
        <MenuItem
          onClick={() => { handleOfficialExport(); handleMenuClose(); }}
          sx={{ fontSize: '.8rem' }}
        >
          Official Export
        </MenuItem>
      </Menu>
    </Box>
    )}
    </>
  );
}

export default ExportAll;